<template>
  <MenuRef :iShow="showColor">
    <div class="inspection">
      <div class="search-cond" style="height: 224px !important" v-show="tableShow">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">企业名称:</div>
            <a-select show-search :allowClear="true" :filterOption="filterOption" v-model="companyId"
              class="Select-style" dropdownClassName="dropdown_style" @select="companySelect"
              style="width: 434px; height: 40px; flex: 1 1 0%">
              <a-select-option value="all" key="all">全部</a-select-option>
              <a-select-option v-for="item in companyList" :value="item.id" :key="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-item">
            <div class="tol-title">负责人:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.one" />
          </div>
          <div class="search-item">
            <div class="tol-title">电话:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.two" />
          </div>
        </div>
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">月发运金额:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.three" />
          </div>
          <div class="search-item">
            <div class="tol-title">客户等级:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.four" />
          </div>
          <div class="search-item">
            <div class="tol-title">业务（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.five" />
          </div>
        </div>
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">面销（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.six" />
          </div>
          <div class="search-item">
            <div class="tol-title">电销（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="form.seven" />
          </div>
          <div class="search-item" style="justify-content: flex-end">
            <div class="btn-cond">
              <div>
                <a-button v-if="permissions.customerManagement.canQuery" @click="reset" class="search-normal">
                  重置
                </a-button>
                <a-button v-else type="primary" disabled> 重置 </a-button>

                <a-button class="search-btn" :style="{ marginLeft: '24px' }" @click="searchData"
                  v-if="permissions.customerManagement.canQuery">
                  查询
                </a-button>
                <a-button :style="{ marginLeft: '24px' }" v-else type="primary" disabled>
                  查询
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-cond" style="height: 90px !important" v-show="!tableShow">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">客户名称:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="userName" />
          </div>
          <div class="search-item">
            <div class="tol-title">电话:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="userPhone" />
          </div>
          <div class="search-item" style="justify-content: flex-end">
            <div class="btn-cond">
              <div>
                <a-button v-if="permissions.customerManagement.canQuery" @click="resetUser" class="search-normal">
                  重置
                </a-button>
                <a-button v-else type="primary" disabled> 重置 </a-button>

                <a-button class="search-btn" :style="{ marginLeft: '24px' }" @click="detailData"
                  v-if="permissions.customerManagement.canQuery">
                  查询
                </a-button>
                <a-button :style="{ marginLeft: '24px' }" v-else type="primary" disabled>
                  查询
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inspection-box">
        <div class="inspection-view">
          <div class="tol-item">
            <div>
              <a-button class="search-btn" @click="openUpdate(1)"
                v-if="tableShow && permissions.customerManagement.canAdd">
                新增
              </a-button>
              <a-button class="search-btn" @click="addUser(1)"
                v-else-if="!tableShow && permissions.customerManagement.canAdd">
                新增
              </a-button>
              <a-button v-else type="primary" disabled> 新增 </a-button>
            </div>
            <div>
              <a-button :style="{ marginLeft: '16px' }" class="search-normal" @click="openUpdate(2)"
                v-if="tableShow && permissions.customerManagement.canEdit">
                修改
              </a-button>
              <a-button :style="{ marginLeft: '16px' }" class="search-normal" @click="addUser(2)"
                v-else-if="!tableShow && permissions.customerManagement.canEdit">
                修改
              </a-button>
              <a-button :style="{
                marginLeft: '16px',
              }" v-else type="primary" disabled>
                修改
              </a-button>
            </div>
            <div v-show="tableShow">
              <a-button :style="{ marginLeft: '16px' }" class="search-normal" @click="exportData"
                v-if="permissions.customerManagement.canExport">
                导出
              </a-button>
              <a-button :style="{
                marginLeft: '16px',
              }" v-else type="primary" disabled>
                导出
              </a-button>
            </div>
            <div>
              <a-button :style="{ marginLeft: '16px' }" class="search-delete" @click="deleteData"
                v-if="tableShow && permissions.customerManagement.canDelete">
                删除
              </a-button>
              <a-button :style="{ marginLeft: '16px' }" class="search-delete" @click="deleteUserData" v-else-if="
                !tableShow && permissions.customerManagement.canDelete
              ">
                删除
              </a-button>
              <a-button :style="{
                marginLeft: '16px',
              }" v-else type="primary" disabled>
                删除
              </a-button>
            </div>
          </div>
          <div class="last-page" v-show="!tableShow">
            <a-button class="search-page" @click="rollbackPage()">
              返回上一页
            </a-button>
          </div>
        </div>
        <div class="inspection-table" ref="tableContainer">
          <a-config-provider :locale="locale">
            <div v-if="tableShow">
              <a-table :customRow="customRow" class="inspection-table" ref="table" size="small"
                :rowSelection="rowSelection" :columns="columns" :data-source="tolInformation"
                :rowKey="(record, index) => record.id" :pagination="pagination"></a-table>
            </div>
            <div v-if="!tableShow">
              <a-table :customRow="customRow" class="inspection-table" ref="table" size="small"
                :rowSelection="rowSelectionUser" :columns="columns1" :data-source="tolInformation1"
                :rowKey="(record, index) => record.id" :pagination="pagination"></a-table>
            </div>
          </a-config-provider>
        </div>
      </div>
      <a-modal v-model="settingUpdate" scrollable width="1200" :title="`企业信息${message}`" :ok-text="'确定'"
        :cancel-text="'取消'" @ok="settingUpdateOk" @cancel="settingUpdateCancel" :wrapClassName="'centered-modal'">
        <a-spin :spinning="loading" tip="数据保存中...">
          <a-form :model="formData" ref="formData" :label-width="120">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="企业名称：">
                  <a-input v-model="formData.name" style="flex: 1; width: 434px; height: 40px" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="企业简称：">
                  <a-input v-model="formData.shortName" style="flex: 1; width: 434px; height: 40px" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="企业负责人：">
                  <a-input v-model="formData.companyPerson" style="flex: 1; width: 434px; height: 40px" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="企业电话：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.phone" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="货物名称：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.goodsName" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="业务负责人：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.businessManager" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="客户等级/折扣：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.clientLevel" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="月发运金额：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.shippingAmount" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="企业地址：">
                  <a-cascader v-model="addressAll" :options="addressOptions" :show-search="{ filter }" placeholder="请选择"
                    @change="handleAddressChange" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="详细地址：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.address" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="面销负责人：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.facePin" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="电销负责人：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.telemarketing" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="是否工商注册：">
                  <a-select style="flex: 1; width: 434px; height: 40px" placeholder="请输入"
                    v-model="formData.isIndustrialRegistered">
                    <a-select-option :value="false">否</a-select-option>
                    <a-select-option :value="true">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="备注：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.remark" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-spin>
      </a-modal>
      <a-modal :title="`客户信息${message}`" wrapClassName="user-modal" :visible="isModalVisible" :ok-text="'确定'"
        :cancel-text="'取消'" @ok="handleOk" @cancel="handleCancel">
        <a-spin :spinning="loading" tip="数据保存中...">
          <a-form :form="formList">
            <a-form-item label="企业名称" style="display: flex">
              <a-input style="flex: 1; width: 434px; height: 40px" v-model="companyName" disabled />
            </a-form-item>
            <a-form-item label="客户名" style="display: flex">
              <a-input style="flex: 1; width: 434px; height: 40px" v-model="formList.realname" />
            </a-form-item>
            <a-form-item label="手机号" style="display: flex">
              <a-input style="flex: 1; width: 434px; height: 40px" v-model="formList.phone" />
              <a-alert v-if="phoneMsg" type="error" :message="`用户手机号是必填的!`" show-icon />
            </a-form-item>
            <a-form-item label="账号状态" style="display: flex">
              <a-select style="flex: 1; width: 434px; height: 40px" v-model="formList.isActive">
                <a-select-option :value="true">启用</a-select-option>
                <a-select-option :value="false">停用</a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-spin>
      </a-modal>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import {
  getCompanyDropdown,
  getCompanyList,
  upsertCompany,
  deleteCompany,
  getUsersByCompany,
  exportCustomerList,
  upsertUser,
  deleteUser,
  getAddressList,
} from "@/api";
import MenuRef from "./common/MenuRef";
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      tableShow: true,
      showColor: ["1"],
      settingUpdate: false,
      form: {
        one: "",
        two: "",
        three: "",
        four: "",
        five: "",
        six: "",
        seven: "",
      },
      addressOptions: [],
      addressAll: [],
      formData: {
        id: "",
        createdAt: "",
        name: "",
        shortName: "",
        companyPerson: "",
        phone: "",
        province: "",
        city: "",
        district: "",
        address: "",
        goodsName: "",
        clientLevel: "",
        shippingAmount: "",
        telemarketing: "",
        facePin: "",
        businessManager: "",
        remark: "",
        isIndustrialRegistered: true,
      },
      formList: {
        openid: "",
        sessionKey: "",
        phone: "",
        password: "",
        salt: "",
        nickname: "",
        gender: "",
        imgUrl: "",
        contact: "",
        realname: "",
        isActive: true,
        type: 1,
        role: 2,
        parentId: "",
        parentName: "",
        isPush: false,
        companyId: "",
        userAddresss: [],
        userTokens: [],
        orders: [],
        logs: [],
      },
      companyName: "",
      locale: zhCN,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      indexNum: 1,
      tolInformation: [],
      companyId: "all",
      companyList: [],
      columns: [
        {
          title: "序号",
          key: "index",
          align: "center",
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "企业名称",
          align: "center",
          customRender: (text, record, index) => {
            return record.name || "/";
          },
        },
        {
          title: "(企业)负责人",
          align: "center",
          customRender: (text, record, index) => {
            return record.companyPerson || "/";
          },
        },
        {
          title: "电话",
          align: "center",
          customRender: (text, record, index) => {
            return record.phone || "/";
          },
          align: "center",
        },
        {
          title: "地址",
          align: "center",
          customRender: (text, record, index) => {
            let addr =
              record.province + record.city + record.district + record.address;
            return addr && addr != 'null' ? addr : "/";
          },
          align: "center",
        },
        {
          title: "货物清单",
          align: "center",
          customRender: (text, record, index) => {
            return record.goodsName || "/";
          },
          align: "center",
        },
        {
          title: "月发运金额",
          align: "center",
          customRender: (text, record, index) => {
            return record.shippingAmount
              ? record.shippingAmount + " 万元"
              : "/";
          },
        },
        {
          title: "客户等级+折扣",
          align: "center",
          customRender: (text, record, index) => {
            return record.clientLevel || "/";
          },
          align: "center",
        },

        {
          title: "业务负责人",
          align: "center",
          customRender: (text, record, index) => {
            return record.businessManager || "/";
          },
          align: "center",
        },
        {
          title: "电销负责人",
          align: "center",
          customRender: (text, record, index) => {
            return record.telemarketing || "/";
          },
          align: "center",
        },
        {
          title: "面销负责人",
          align: "center",
          customRender: (text, record, index) => {
            return record.facePin || "/";
          },
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 120,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("div", [
              h(
                "span",
                {
                  style: {
                    cursor: "pointer",
                    color: "#6699FF",
                  },
                  on: {
                    click: () => {
                      this.companyName = record.name;
                      this.formList.companyId = record.id;
                      this.comId = record.id;
                      this.userData = { ...record };
                      this.detailData();
                    },
                  },
                },
                "详情"
              ),
            ]);
          },
          align: "center",
        },
      ],
      columns1: [
        {
          title: "序号",
          key: "index",
          align: "center",
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "企业名称",
          align: "center",
          customRender: (text, record, index) => {
            return record.companyName || "/";
          },
        },
        {
          title: "客户",
          align: "center",
          customRender: (text, record, index) => {
            return record.realname || "/";
          },
        },
        {
          title: "电话",
          align: "center",
          customRender: (text, record, index) => {
            return record.phone || "/";
          },
        },
        {
          title: "货物名称",
          align: "center",
          customRender: (text, record, index) => {
            return record.goodsName || "/";
          },
          align: "center",
        },
        {
          title: "月发运金额（元）",
          align: "center",
          customRender: (text, record, index) => {
            return record.shippingAmount || "/";
          },
          align: "center",
        },
        {
          title: "账号状态",
          align: "center",
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("a-switch", {
              style: {
                width: "48px",
                height: "24px",
              },
              props: {
                checked: record.isActive,
                checkedChildren: "开",
                unCheckedChildren: "关",
              },
              on: {
                // change: () => this.handleSwitchChange(record),
              },
            });
          },
          align: "center",
        },
      ],
      tolInformation1: [],
      tableHeight: 259,
      // 初始化
      dataCount: 0,
      pageSize: 10,
      pagination: {
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOptions: ["15", "20", "30", "50"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
        size: "middle",
      },
      selectRow: [],
      selectRowUser: [],
      loading: false,
      settingUpdate: false,
      isModalVisible: false,
      phoneMsg: false,
      userData: {},
      message: "添加",
      userPhone: "",
      userName: "",
      comId: "",
    };
  },
  methods: {
    moment,
    companySelect(id) {
      this.companyId = id;
    },
    rollbackPage() {
      this.tableShow = true;
      this.basicsData();
    },
    openUpdate(type) {
      if (type == 1) {
        this.message = "添加";
        this.settingUpdate = true;
        (this.formData = {
          id: "",
          createdAt: "",
          name: "",
          shortName: "",
          companyPerson: "",
          phone: "",
          address: "",
          goodsName: "",
          clientLevel: "",
          shippingAmount: "",
          telemarketing: "",
          facePin: "",
          businessManager: "",
          remark: "",
          isIndustrialRegistered: true,
        }),
          (this.formData.createdAt = moment().toISOString());
        delete this.formData.id;
      } else {
        if (Object.keys(this.selectRow).length !== 0) {
          this.message = "修改";
          let list = this.selectRow[0];
          this.formData.id = list.id;
          this.formData.createdAt = list.createdAt;
          this.formData.name = list.name;
          this.formData.shortName = list.shortName;
          this.formData.companyPerson = list.companyPerson;
          this.formData.phone = list.phone;
          this.formData.address = list.address;
          this.formData.goodsName = list.goodsName;
          this.formData.clientLevel = list.clientLevel;
          this.formData.shippingAmount = list.shippingAmount;
          this.formData.telemarketing = list.telemarketing;
          this.formData.facePin = list.facePin;
          this.formData.businessManager = list.businessManager;
          this.formData.remark = list.remark;
          this.formData.isIndustrialRegistered = list.isIndustrialRegistered;
          this.addressAll = [list.province, list.city, list.district];
          this.settingUpdate = true;
        } else {
          this.$Message.warning("请选择所要修改的一行！");
        }
      }
    },
    settingUpdateOk() {
      this.saveData(this.formData);
    },
    settingUpdateCancel() {
      this.$emit("close");
    },
    async saveData(params) {
      this.loading = true;
      await upsertCompany(params).then((res) => {
        if (res.statusCode == 200) {
          this.$Message.success(`数据${this.message}成功！`);
          this.basicsData();

        } else {
          this.loading = false;
          this.$Message.error(`数据${this.message}失败！`);
        }
      });
    },
    deleteData() {
      if (this.selectRow.length > 0) {
        let list = [];
        this.selectRow.forEach((item) => {
          list.push({ id: item.id });
        });
        this.$Modal.confirm({
          title: "操作提醒！！！",
          content: "您确定将该行删除么？",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            this.detailData(2, this.selectRow[0]);
            setTimeout(() => {
              deleteCompany(list).then((res) => {
                if (res.statusCode == 200) {
                  this.basicsData();
                } else {
                  this.$Message.error("企业数据删除失败！");
                }
              });
            }, 500);
          },
          onCancel: () => {
            this.$message.info("您已取消操作！");
          },
        });
      } else {
        this.$Message.warning("请选择所要删除的数据行！");
      }
    },
    reset() {
      this.companyId = "all";
      this.form = {
        one: "",
        two: "",
        three: "",
        four: "",
        five: "",
        six: "",
        seven: "",
      };
      this.basicsData();
    },
    resetUser() {
      this.userName = "";
      this.userPhone = "";
      this.detailData();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    customRow(record, index) {
      return {
        style: {
          // 字体颜色
          //color: "#cceaff",
          // 行背景色
          // "background-color": "#2a3347",
          cursor: "pointer",
        },
        on: {
          // 鼠标单击行
          click: (event) => {
            // this.taskCheckData(record);
          },
        },
      };
    },
    addUser(type) {
      if (type == 1) {
        this.message = "添加";
        this.isModalVisible = true;
      } else {
        if (this.selectRowUser.length > 0) {
          this.formList = {};
          this.message = "修改";
          this.isModalVisible = true;
          let list = this.selectRowUser[0];
          this.formList.id = list.id;
          this.formList.realname = list.realname;
          this.formList.phone = list.phone;
          this.formList.isActive = list.isActive;
          this.formList.companyId = list.companyId;
        } else {
          this.$Message.warning("请选择所要修改的一行！");
        }
      }
    },
    handleOk() {
      this.phoneMsg = false;

      if (!this.formList.phone) {
        this.phoneMsg = true;
        return;
      }

      this.loading = true;
      this.formList.type = 1;
      this.formList.nickname = this.formList.realname;
      upsertUser(this.formList).then((res) => {
        if (res.statusCode == 200) {
          this.loading = false;
          this.$Message.success(`数据${this.message}成功！`);
          this.detailData();
          this.handleCancel();
        } else {
          if (res.message == "相同用户已存在") {
            this.$Message.error(`存在相同用户，请输入其它号码！`);
          } else {
            this.$Message.error(res.message);
          }
          this.loading = false;
        }
        this.formList.companyId = this.comId;
      });
    },
    handleCancel() {
      this.isModalVisible = false;
      this.phoneMsg = false;
      this.formList = {
        openid: "",
        sessionKey: "",
        phone: "",
        password: "",
        salt: "",
        nickname: "",
        gender: "",
        imgUrl: "",
        contact: "",
        realname: "",
        isActive: true,
        type: 1,
        role: 2,
        parentId: "",
        parentName: "",
        isPush: false,
        userAddresss: [],
        userTokens: [],
        orders: [],
        logs: [],
      };
    },
    deleteUserData(data) {
      let list = [];
      console.log("1111");
      console.log(data);
      if (data && data.length > 0) {
        data.forEach((item) => {
          list.push({ id: item.id });
        });
        deleteUser(list).then((res) => {
          if (res.statusCode == 200) {
            this.$Message.success("企业及关联用户删除成功！");
          } else {
            this.$Message.error("企业及关联用户删除失败！");
          }
        });
      } else {
        if (this.selectRowUser.length > 0) {
          this.selectRowUser.forEach((item) => {
            list.push({ id: item.id });
          });
          this.$Modal.confirm({
            title: "操作提醒！！！",
            content: "您确定将该行删除么？",
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
              deleteUser(list).then((res) => {
                if (res.statusCode == 200) {
                  this.$Message.success("数据删除成功！");
                  this.detailData();
                } else {
                  this.$Message.error("数据删除失败！");
                }
              });
            },
            onCancel: () => {
              this.$message.info("您已取消操作！");
            },
          });
        } else {
          this.$Message.warning("请选择所要删除的数据行！");
        }
      }
    },
    detailData(type, list) {
      let dataList = [];
      let comId = "";
      let phone = "";
      let name = "";
      if (type == 2) {
        comId = list.id;
        phone = "";
        name = "";
      } else {
        comId = this.formList.companyId;
        phone = this.userPhone;
        name = this.userName;
      }

      getUsersByCompany(comId, phone, name).then((res) => {
        if (type == 2) {
          this.tableShow = true;
        } else {
          this.tableShow = false;
        }
        if (res.data.list.length > 0) {
          if (type == 2) {
            //当删除企业时对应的用户进行删除操作
            let data = [];
            res.data.list.forEach((item) => {
              data.push({ id: item.id });
            });
            this.deleteUserData(data);
          } else {
            res.data.list.forEach((item) => {
              dataList.push({
                id: item.id,
                companyName: item.company.name,
                realname: item.realname,
                phone: item.phone,
                goodsName: this.userData.goodsName,
                shippingAmount: this.userData.shippingAmount,
                isActive: item.isActive,
                companyId: item.company.id,
              });
            });
            this.formList.companyId = dataList[0].companyId;
            this.tolInformation1 = dataList;
            this.dataCount = res.data.total;
            this.pagination.total = this.dataCount;
          }
        } else {
          this.tolInformation1 = [];
          this.dataCount = 0;
          this.pagination.total = this.dataCount;
        }
      });
    },
    getAddress() {
      getAddressList().then((res) => {
        if (res.data.list.length > 0) {
          this.addressOptions = this.transformAllAddressData(res.data.list);
        }
      });
    },
    transformAllAddressData(data) {
      return data.map((province) => ({
        value: province.name,
        label: province.name,
        children: province.city.map((city) => ({
          value: city.name,
          label: city.name,
          children: city.area.map((area) => ({
            value: area,
            label: area,
          })),
        })),
      }));
    },
    handleAddressChange(value, selectedOptions) {
      if (selectedOptions.length === 3) {
        this.addressAll = value;
        this.formData.province = selectedOptions[0].label;
        this.formData.city = selectedOptions[1].label;
        this.formData.district = selectedOptions[2].label;
      }
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
    basicsData() {
      getCompanyList({
        page: this.pagination.pageNo,
        size: this.pagination.pageSize,
        id: this.companyId == "all" ? "" : this.companyId,
        companyPerson: this.form.one,
        phone: this.form.two,
        shippingAmount: this.form.three,
        clientLevel: this.form.four,
        businessManager: this.form.five,
        facePin: this.form.six,
        telemarketing: this.form.seven,
      }).then((res) => {
        if (res.data) {
          this.loading = false;
          this.settingUpdate = false;
          this.tolInformation = res.data.list;
          this.dataCount = res.data.total;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = this.dataCount;
          this.selectRow = [];
          this.selectRowUser = [];
        }
      });
    },
    async onPageChange(page) {
      this.pagination.pageNo = page;
      this.pagination.current = page;
      await this.basicsData();
    },
    searchData() {
      this.basicsData();
    },
    getCompanys() {
      getCompanyDropdown().then((res) => {
        if (res.data.list.length > 0) {
          this.companyList = res.data.list;
        }
      });
    },
    exportData() {
      let params = {};

      params = {
        header: [
          "企业名称",
          "企业简称",
          "企业负责人",
          "企业电话",
          "货物名称",
          "企业地址",
          "客户等级/折扣",
          "月发运金额",
          "业务负责人",
          "面销负责人",
          "电销负责人",
          "是否工商注册",
          "备注",
        ],

        headervalues: [
          "name",
          "shortName",
          "companyPerson",
          "phone",
          "goodsName",
          "address",
          "clientLevel",
          "shippingAmount",
          "businessManager",
          "facePin",
          "telemarketing",
          "isIndustrialRegistered",
          "remark",
        ],
        id: this.companyId == "all" ? "" : this.companyId,
        companyPerson: this.form.one,
        phone: this.form.two,
        shippingAmount: this.form.three,
        clientLevel: this.form.four,
        businessManager: this.form.five,
        facePin: this.form.six,
        telemarketing: this.form.seven,
      };

      exportCustomerList({ ...params }).then((data) => {
        if (!data || data.size <= 0) {
          this.$Message.error("没有数据导出失败");
          return;
        }

        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().format("YYYY-MM-DD")}-订单数据.xlsx`
        );

        document.body.appendChild(link);
        link.click();
      });
    },
  },
  mounted() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.getCompanys();
    this.getAddress();
    this.basicsData();
  },
  computed: {
    rowSelection() {
      return {
        type: "radio",
        selectedRowKeys:this.selectRow.map(item=> item.id),
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRow = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectRow = selectedRows;
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectRow = selectedRows;
        },
      };
    },
    rowSelectionUser() {
      return {
        type: "radio",
        selectedRowKeys:this.selectRowUser.map(item=> item.id),
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRowUser = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectRowUser = selectedRows;
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectRowUser = selectedRows;
        },
      };
    },
  },
  watch: {
    // 表格高度自适应
    tolInformation: function (newVal, oldVal) {
      if (newVal.length == 0) {
        document.getElementsByClassName(
          "ant-spin-nested-loading"
        )[0].style.height = 40 + "px";
      } else {
        if (newVal.length != this.pageSize) {
          document.getElementsByTagName("table")[0].style.height = 0 + "px";
        } else {
          document.getElementsByClassName(
            "ant-spin-nested-loading"
          )[0].style.height = 100 + "%";
          document.getElementsByTagName("table")[0].style.height = 100 + "%";
        }
      }
    },
  },
};
</script>

<style lang="less">
.inspection {
  height: 100%;
  width: 100%;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search-normal {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #969998;
    border-color: #e3e6e4;
    width: 80px;
    height: 40px;
  }

  .search-normal:hover,
  .search-normal:active,
  .search-normal:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-delete {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff6b4d;
    border-color: #ff6b4d;
    width: 80px;
    height: 40px;
  }

  .search-delete:hover,
  .search-delete:active,
  .search-delete:focus {
    background: transparent;
    border-radius: 4px;
    color: #ff6b4d;
    border-color: #ff6b4d;
  }

  .search-page {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #14cc76;
    border-color: #14cc76;
    width: 104px !important;
    height: 40px;
  }

  .search-page:hover,
  .search-page:active,
  .search-page:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-cond {
    width: 100%;
    height: 224px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;

    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .search-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;

        .tol-title {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #313332;
          line-height: 22px;
          font-style: normal;
          margin-right: 10px;
        }
      }
    }

    .search-button {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      .btn-cond {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  .inspection-box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;

    .title {
      display: block;
      border-bottom: solid 1px #384057;
      padding-bottom: 10px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M;
      line-height: 28px;
      text-align: left;
    }

    .inspection-view {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      height: 42px;

      .tol-item {
        display: flex;
        width: 70%;
        align-items: center;
        justify-content: flex-start;

        .tol-add {
          margin-left: 20px;
        }

        .tol-title {
          margin-right: 6px;
          overflow-wrap: break-word;
          color: rgba(207, 214, 230, 1);
          font-size: 16px;
          font-family: Roboto-Medium;
        }

        .Select-style {
          width: 336px;
          height: 40px;
        }
      }

      .last-page {
        display: flex;
        width: 30%;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .inspection-table {
      height: calc(~"100% - 182px");
      padding-top: 4px;

      // 表格
      .inspection-table {
        height: 100%;

        .ant-checkbox-inner {
          background-color: transparent;
          border-color: rgba(132, 161, 219, 1);
        }

        //  点击时选框样式
        .ant-checkbox-wrapper-checked {
          .ant-checkbox-checked {
            background: #3384ff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/ .ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/ .ant-table-thead {
  background: #f0f0f0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #313332;
}

/deep/.ant-table-small>.ant-table-content>.ant-table-body {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #313332;
  line-height: 22px;
}

/deep/.ant-switch-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-wrapper-checked .ant-checkbox-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-inner {
  border: 1px solid #14cc76;
}

/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background: #14cc76;
}

/deep/ .ant-checkbox-checked::after {
  border: 1px solid #14cc76;
}

/deep/ .ant-spin-nested-loading {
  height: unset !important;
}

/deep/.ant-modal {
  display: flex;
  justify-content: center;
}

/deep/.ant-calendar-picker-input.ant-input {
  height: 40px !important;
}

/deep/.ant-form-item {
  justify-content: flex-end;
}

/deep/.ant-select-search__field__mirror {
  opacity: 1;
}

/deep/.ant-cascader-input.ant-input {
  width: 434px !important;
  height: 40px !important;
}
</style>
